function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { Animated, Easing, I18nManager, PanResponder, Platform, StyleSheet, View } from "react-native";
var TRACK_SIZE = 4;
var THUMB_SIZE = 20;
var Rect = /*#__PURE__*/ function() {
    "use strict";
    function Rect(x, y, width, height) {
        _class_call_check(this, Rect);
        _define_property(this, "x", void 0);
        _define_property(this, "y", void 0);
        _define_property(this, "width", void 0);
        _define_property(this, "height", void 0);
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    _create_class(Rect, [
        {
            key: "containsPoint",
            value: function containsPoint(x, y) {
                return x >= this.x && y >= this.y && x <= this.x + this.width && y <= this.y + this.height;
            }
        }
    ]);
    return Rect;
}();
var DEFAULT_ANIMATION_CONFIGS = {
    spring: {
        friction: 7,
        tension: 100
    },
    timing: {
        duration: 150,
        easing: Easing.inOut(Easing.ease),
        delay: 0
    }
};
var THUMB_TOUCH_SIZE = {
    width: 40,
    height: 40
};
/**
 * A "slider" UI component that allows the user to select a continuous
 * numerical value.
 *
 * Dev Notes:
 *
 * Adapted from https://github.com/jeanregisser/react-native-slider
 * Should replace with react-native-community/slider at some point but it doesn't support thumbStyle
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-100}
 */ export var RNSlider = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(RNSlider, PureComponent);
    function RNSlider() {
        _class_call_check(this, RNSlider);
        var _this;
        _this = _call_super(this, RNSlider, arguments), _define_property(_this, "_previousLeft", 0), _define_property(_this, "_containerSize", void 0), _define_property(_this, "_thumbSize", void 0), _define_property(_this, "_trackSize", void 0), _define_property(_this, "state", {
            containerSize: {
                width: 0,
                height: 0
            },
            trackSize: {
                width: 0,
                height: 0
            },
            thumbSize: {
                width: 0,
                height: 0
            },
            allMeasured: false,
            value: new Animated.Value(_this.props.value)
        }), _define_property(_this, "_handleStartShouldSetPanResponder", function(e) {
            // Should we become active when the user presses down on the thumb?
            return _this._thumbHitTest(e);
        }), _define_property(_this, "_handleMoveShouldSetPanResponder", function() {
            // Should we become active when the user moves a touch over the thumb?
            return false;
        }), _define_property(_this, "_handlePanResponderGrant", function() {
            var _this_props_onSlidingStart, _this_props;
            _this._previousLeft = _this._getThumbLeft(_this._getCurrentValue());
            (_this_props_onSlidingStart = (_this_props = _this.props).onSlidingStart) === null || _this_props_onSlidingStart === void 0 ? void 0 : _this_props_onSlidingStart.call(_this_props, _this._getCurrentValue());
        }), _define_property(_this, "_handlePanResponderMove", function(_, gestureState) {
            var _this_props_onValueChange, _this_props;
            if (_this.props.disabled) {
                return;
            }
            _this._setCurrentValue(_this._getValue(gestureState));
            (_this_props_onValueChange = (_this_props = _this.props).onValueChange) === null || _this_props_onValueChange === void 0 ? void 0 : _this_props_onValueChange.call(_this_props, _this._getCurrentValue());
        }), _define_property(_this, "_handlePanResponderRequestEnd", function() {
            // Should we allow another component to take over this pan?
            return false;
        }), _define_property(_this, "_handlePanResponderEnd", function(_, gestureState) {
            var _this_props_onSlidingComplete, _this_props;
            if (_this.props.disabled) {
                return;
            }
            _this._setCurrentValue(_this._getValue(gestureState));
            (_this_props_onSlidingComplete = (_this_props = _this.props).onSlidingComplete) === null || _this_props_onSlidingComplete === void 0 ? void 0 : _this_props_onSlidingComplete.call(_this_props, _this._getCurrentValue());
        }), _define_property(_this, "_measureContainer", function(x) {
            _this._handleMeasure('_containerSize', x);
        }), _define_property(_this, "_measureTrack", function(x) {
            _this._handleMeasure('_trackSize', x);
        }), _define_property(_this, "_measureThumb", function(x) {
            _this._handleMeasure('_thumbSize', x);
        }), _define_property(_this, "_handleMeasure", function(name, x) {
            var _x_nativeEvent_layout = x.nativeEvent.layout, width = _x_nativeEvent_layout.width, height = _x_nativeEvent_layout.height;
            var size = {
                width: width,
                height: height
            };
            var currentSize = _this[name];
            if (currentSize && width === currentSize.width && height === currentSize.height) {
                return;
            }
            _this[name] = size;
            if (_this._containerSize && _this._trackSize && _this._thumbSize) {
                _this.setState({
                    containerSize: _this._containerSize,
                    trackSize: _this._trackSize,
                    thumbSize: _this._thumbSize,
                    allMeasured: true
                });
            }
        }), _define_property(_this, "_getRatio", function(value) {
            return (value - _this.props.minimumValue) / (_this.props.maximumValue - _this.props.minimumValue);
        }), _define_property(_this, "_getThumbLeft", function(value) {
            var nonRtlRatio = _this._getRatio(value);
            var ratio = I18nManager.isRTL ? 1 - nonRtlRatio : nonRtlRatio;
            return ratio * (_this.state.containerSize.width - _this.state.thumbSize.width);
        }), _define_property(_this, "_getValue", function(gestureState) {
            var length = _this.state.containerSize.width - _this.state.thumbSize.width;
            var thumbLeft = _this._previousLeft + gestureState.dx;
            var nonRtlRatio = thumbLeft / length;
            var ratio = I18nManager.isRTL ? 1 - nonRtlRatio : nonRtlRatio;
            if (_this.props.step) {
                return Math.max(_this.props.minimumValue, Math.min(_this.props.maximumValue, _this.props.minimumValue + Math.round(ratio * (_this.props.maximumValue - _this.props.minimumValue) / _this.props.step) * _this.props.step));
            }
            return Math.max(_this.props.minimumValue, Math.min(_this.props.maximumValue, ratio * (_this.props.maximumValue - _this.props.minimumValue) + _this.props.minimumValue));
        }), // @ts-expect-error
        _define_property(_this, "_getCurrentValue", function() {
            return _this.state.value.__getValue();
        }), _define_property(_this, "_setCurrentValue", function(value) {
            _this.state.value.setValue(value);
        }), _define_property(_this, "_setCurrentValueAnimated", function(value) {
            var animationType = _this.props.animationType;
            var animationConfig = Object.assign({}, DEFAULT_ANIMATION_CONFIGS[animationType], {
                toValue: value,
                useNativeDriver: false
            });
            if (!(Platform.OS === 'android' && global.e2e)) {
                Animated[animationType](_this.state.value, animationConfig).start();
            }
        }), _define_property(_this, "_getTouchOverflowSize", function() {
            var state = _this.state;
            var size = {
                width: 0,
                height: 0
            };
            if (state.allMeasured === true) {
                size.width = Math.max(0, THUMB_TOUCH_SIZE.width - state.thumbSize.width);
                size.height = Math.max(0, THUMB_TOUCH_SIZE.height - state.containerSize.height);
            }
            return size;
        }), _define_property(_this, "_getTouchOverflowStyle", function() {
            var _this__getTouchOverflowSize = _this._getTouchOverflowSize(), width = _this__getTouchOverflowSize.width, height = _this__getTouchOverflowSize.height;
            var touchOverflowStyle = {};
            if (width !== undefined && height !== undefined) {
                var verticalMargin = -height / 2;
                touchOverflowStyle.marginTop = verticalMargin;
                touchOverflowStyle.marginBottom = verticalMargin;
                var horizontalMargin = -width / 2;
                touchOverflowStyle.marginLeft = horizontalMargin;
                touchOverflowStyle.marginRight = horizontalMargin;
            }
            if (_this.props.debugTouchArea === true) {
                touchOverflowStyle.backgroundColor = 'orange';
                touchOverflowStyle.opacity = 0.5;
            }
            return touchOverflowStyle;
        }), _define_property(_this, "_thumbHitTest", function(e) {
            var nativeEvent = e.nativeEvent;
            var thumbTouchRect = _this._getThumbTouchRect();
            return thumbTouchRect.containsPoint(nativeEvent.locationX, nativeEvent.locationY);
        }), _define_property(_this, "_getThumbTouchRect", function() {
            var state = _this.state;
            var touchOverflowSize = _this._getTouchOverflowSize();
            return new Rect(touchOverflowSize.width / 2 + _this._getThumbLeft(_this._getCurrentValue()) + (state.thumbSize.width - THUMB_TOUCH_SIZE.width) / 2, touchOverflowSize.height / 2 + (state.containerSize.height - THUMB_TOUCH_SIZE.height) / 2, THUMB_TOUCH_SIZE.width, THUMB_TOUCH_SIZE.height);
        }), _define_property(_this, "_renderDebugThumbTouchRect", function(thumbLeft) {
            var thumbTouchRect = _this._getThumbTouchRect();
            var positionStyle = {
                left: thumbLeft,
                top: thumbTouchRect.y,
                width: thumbTouchRect.width,
                height: thumbTouchRect.height
            };
            return /*#__PURE__*/ _jsx(Animated.View, {
                style: [
                    defaultStyles.debugThumbTouchArea,
                    positionStyle
                ],
                pointerEvents: "none"
            });
        }), _define_property(_this, "_panResponder", PanResponder.create({
            onStartShouldSetPanResponder: _this._handleStartShouldSetPanResponder,
            onMoveShouldSetPanResponder: _this._handleMoveShouldSetPanResponder,
            onPanResponderGrant: _this._handlePanResponderGrant,
            onPanResponderMove: _this._handlePanResponderMove,
            onPanResponderRelease: _this._handlePanResponderEnd,
            onPanResponderTerminationRequest: _this._handlePanResponderRequestEnd,
            onPanResponderTerminate: _this._handlePanResponderEnd
        }));
        return _this;
    }
    _create_class(RNSlider, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var nextProps = this.props;
                var newValue = nextProps.value;
                if (prevProps.value !== newValue) {
                    if (this.props.animateTransitions) {
                        this._setCurrentValueAnimated(newValue);
                    } else {
                        this._setCurrentValue(newValue);
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, minimumValue = _this_props.minimumValue, maximumValue = _this_props.maximumValue, minimumTrackTintColor = _this_props.minimumTrackTintColor, maximumTrackTintColor = _this_props.maximumTrackTintColor, thumbTintColor = _this_props.thumbTintColor, style = _this_props.style, trackStyle = _this_props.trackStyle, thumbStyle = _this_props.thumbStyle, debugTouchArea = _this_props.debugTouchArea, onValueChange = _this_props.onValueChange, animationType = _this_props.animationType, animateTransitions = _this_props.animateTransitions, other = _object_without_properties(_this_props, [
                    "minimumValue",
                    "maximumValue",
                    "minimumTrackTintColor",
                    "maximumTrackTintColor",
                    "thumbTintColor",
                    "style",
                    "trackStyle",
                    "thumbStyle",
                    "debugTouchArea",
                    "onValueChange",
                    "animationType",
                    "animateTransitions"
                ]);
                var _this_state = this.state, value = _this_state.value, containerSize = _this_state.containerSize, thumbSize = _this_state.thumbSize, allMeasured = _this_state.allMeasured;
                var mainStyles = defaultStyles;
                var thumbLeft = value.interpolate({
                    inputRange: [
                        minimumValue,
                        maximumValue
                    ],
                    outputRange: I18nManager.isRTL ? [
                        0,
                        -(containerSize.width - thumbSize.width)
                    ] : [
                        0,
                        containerSize.width - thumbSize.width
                    ]
                });
                var minimumTrackWidth = value.interpolate({
                    inputRange: [
                        minimumValue,
                        maximumValue
                    ],
                    outputRange: [
                        0,
                        containerSize.width - thumbSize.width
                    ]
                });
                var valueVisibleStyle = {};
                if (!allMeasured) {
                    valueVisibleStyle.opacity = 0;
                }
                var minimumTrackStyle = _object_spread({
                    position: 'absolute',
                    width: Animated.add(minimumTrackWidth, thumbSize.width / 2),
                    backgroundColor: minimumTrackTintColor
                }, valueVisibleStyle);
                var touchOverflowStyle = this._getTouchOverflowStyle();
                return /*#__PURE__*/ _jsxs(View, _object_spread_props(_object_spread({}, other), {
                    style: [
                        mainStyles.container,
                        style
                    ],
                    onLayout: this._measureContainer,
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: [
                                {
                                    backgroundColor: maximumTrackTintColor
                                },
                                mainStyles.track,
                                trackStyle
                            ],
                            renderToHardwareTextureAndroid: true,
                            onLayout: this._measureTrack
                        }),
                        /*#__PURE__*/ _jsx(Animated.View, {
                            renderToHardwareTextureAndroid: true,
                            style: [
                                mainStyles.track,
                                trackStyle,
                                minimumTrackStyle
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Animated.View, {
                            onLayout: this._measureThumb,
                            renderToHardwareTextureAndroid: true,
                            style: [
                                {
                                    backgroundColor: thumbTintColor
                                },
                                mainStyles.thumb,
                                thumbStyle,
                                _object_spread({
                                    transform: [
                                        {
                                            translateX: thumbLeft
                                        },
                                        {
                                            translateY: 0
                                        }
                                    ]
                                }, valueVisibleStyle)
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({
                            renderToHardwareTextureAndroid: true,
                            style: [
                                defaultStyles.touchArea,
                                touchOverflowStyle
                            ]
                        }, this.props.allowSliding ? this._panResponder.panHandlers : undefined), {
                            children: debugTouchArea === true && this._renderDebugThumbTouchRect(minimumTrackWidth)
                        }))
                    ]
                }));
            }
        },
        {
            key: "_getPropsForComponentUpdate",
            value: function _getPropsForComponentUpdate(props) {
                var value = props.value, onValueChange = props.onValueChange, onSlidingStart = props.onSlidingStart, onSlidingComplete = props.onSlidingComplete, style = props.style, trackStyle = props.trackStyle, thumbStyle = props.thumbStyle, otherProps = _object_without_properties(props, [
                    "value",
                    "onValueChange",
                    "onSlidingStart",
                    "onSlidingComplete",
                    "style",
                    "trackStyle",
                    "thumbStyle"
                ]);
                return otherProps;
            }
        }
    ]);
    return RNSlider;
}(PureComponent);
_define_property(RNSlider, "defaultProps", {
    value: 0,
    minimumValue: 0,
    maximumValue: 1,
    step: 0,
    minimumTrackTintColor: '#3f3f3f',
    maximumTrackTintColor: '#b3b3b3',
    thumbTintColor: '#343434',
    debugTouchArea: false,
    animationType: 'timing',
    allowSliding: true
});
var defaultStyles = StyleSheet.create({
    container: {
        height: 40,
        justifyContent: 'center'
    },
    track: {
        height: TRACK_SIZE,
        borderRadius: TRACK_SIZE / 2
    },
    thumb: {
        position: 'absolute',
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        borderRadius: THUMB_SIZE / 2
    },
    touchArea: {
        position: 'absolute',
        backgroundColor: 'transparent',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    debugThumbTouchArea: {
        position: 'absolute',
        backgroundColor: 'green',
        opacity: 0.5
    }
});
